import {
  LayoutDashboard, ShoppingCart, Megaphone, MessageSquareWarning, BarChart3,
  Shirt, Layers, Palette, Ruler, Scissors, Warehouse, Factory, Printer,
  ArrowLeftRight, Lock, ClipboardCheck, SlidersHorizontal, Store, Globe, Scale,
  Users, ShieldCheck, KeyRound, ScrollText, Settings as SettingsIcon, Package, Undo2,
  ShoppingBag, FileText, ClipboardList, PackageCheck, Truck, PackagePlus, Gauge, BellRing,
  Landmark, BookText, ListTree, CalendarClock, Wallet, ReceiptText, HandCoins, Coins, Banknote,
  Calculator, Boxes, GitBranch, Hourglass, LayoutGrid,
} from "lucide-react";

// Each item: { label, path, icon, perm }
export const NAV = [
  {
    section: null,
    items: [{ label: "Dashboard", path: "/", icon: LayoutDashboard, perm: "dashboard.admin" }],
  },
  {
    section: "Online Shop",
    items: [
      { label: "Pesanan", path: "/orders", icon: ShoppingCart, perm: "orders.view" },
      { label: "Iklan", path: "/advertising", icon: Megaphone, perm: "advertising.view" },
      { label: "Komplain", path: "/complaints", icon: MessageSquareWarning, perm: "complaints.view" },
      { label: "Analitik Penjualan", path: "/sales-analytics", icon: BarChart3, perm: "analytics.sales" },
    ],
  },
  {
    section: "Online Shop Monitoring",
    items: [
      { label: "Online Shop Dashboard", path: "/oms/dashboard", icon: Gauge, perm: "oms.view" },
      { label: "Monitoring Chat", path: "/oms/chat", icon: MessageSquareWarning, perm: "oms.view" },
      { label: "Monitoring Toko", path: "/oms/store", icon: Store, perm: "oms.view" },
      { label: "Daily Store Assessment", path: "/oms/assessment", icon: ClipboardCheck, perm: "oms.view" },
      { label: "Daily Report History", path: "/oms/history", icon: FileText, perm: "oms.view" },
    ],
  },
  {
    section: "Produk",
    items: [
      { label: "Varian Produk", path: "/products", icon: Shirt, perm: "products.view" },
      { label: "Jenis Bahan", path: "/master/fabric_types", icon: Layers, perm: "masters.view" },
      { label: "Warna", path: "/master/colors", icon: Palette, perm: "masters.view" },
      { label: "Ukuran", path: "/master/sizes", icon: Ruler, perm: "masters.view" },
      { label: "Jenis Lengan", path: "/master/sleeve_types", icon: Scissors, perm: "masters.view" },
    ],
  },
  {
    section: "Inventory",
    items: [
      { label: "Dashboard Inventory", path: "/inventory/dashboard", icon: Gauge, perm: "inventory.dashboard.view" },
      { label: "Saldo Awal Inventory", path: "/inventory/opening", icon: Warehouse, perm: "inventory.opening.view" },
      { label: "Inventory Pusat", path: "/inventory/pusat", icon: Warehouse, perm: "inventory.view" },
      { label: "Inventory Konveksi", path: "/inventory/konveksi", icon: Factory, perm: "inventory.view" },
      { label: "Inventory Digital Printing", path: "/inventory/printing", icon: Printer, perm: "inventory.view" },
      { label: "Inventory Umum", path: "/inventory/umum", icon: Boxes, perm: "inventory.general.view" },
      { label: "Pemakaian Internal", path: "/inventory/pemakaian-internal", icon: PackagePlus, perm: "inventory.general.issue" },
      { label: "Transfer Stok", path: "/inventory/transfer", icon: ArrowLeftRight, perm: "inventory.transfer" },
      { label: "Reservasi Stok", path: "/inventory/reservasi", icon: Lock, perm: "reservations.view" },
      { label: "Stock Opname", path: "/inventory/opname", icon: ClipboardCheck, perm: "inventory.opname" },
      { label: "Penyesuaian Stok", path: "/inventory/adjustment", icon: SlidersHorizontal, perm: "inventory.adjust" },
      { label: "Retur", path: "/inventory/retur", icon: Undo2, perm: "inventory.view" },
      { label: "Migrasi Catch Weight", path: "/inventory/catch-weight-migration", icon: Boxes, perm: "inventory.catch_weight.migrate.view" },
    ],
  },
  {
    section: "Purchasing",
    items: [
      { label: "Dashboard Purchasing", path: "/purchasing/dashboard", icon: Gauge, perm: "purchasing.view" },
      { label: "Supplier", path: "/purchasing/suppliers", icon: Truck, perm: "purchasing.view" },
      { label: "Permintaan Pembelian", path: "/purchasing/requests", icon: FileText, perm: "purchasing.view" },
      { label: "Purchase Order", path: "/purchasing/orders", icon: ClipboardList, perm: "purchasing.view" },
      { label: "Penerimaan Barang", path: "/purchasing/receiving", icon: PackageCheck, perm: "purchasing.view" },
    ],
  },
  {
    section: "Produksi",
    items: [
      { label: "Dashboard Produksi", path: "/production/dashboard", icon: Gauge, perm: "production.view" },
      { label: "Production Order", path: "/production/orders", icon: Factory, perm: "production.view" },
      { label: "Material Request", path: "/production/material-requests", icon: PackagePlus, perm: "production.view" },
    ],
  },
  {
    section: "Digital Printing",
    items: [
      { label: "Dashboard Digital Printing", path: "/digital-printing/dashboard", icon: Gauge, perm: "digital_printing.dashboard.view" },
      { label: "Job Digital Printing", path: "/digital-printing/jobs", icon: ClipboardList, perm: "digital_printing.job.view" },
      { label: "Production Queue", path: "/digital-printing/queue", icon: Factory, perm: "digital_printing.production.view" },
      { label: "QC Digital Printing", path: "/digital-printing/qc", icon: ClipboardCheck, perm: "digital_printing.qc.view" },
      { label: "Material Digital Printing", path: "/digital-printing/material", icon: Package, perm: "digital_printing.material.view" },
      { label: "Konversi Satuan (UOM)", path: "/digital-printing/conversions", icon: ArrowLeftRight, perm: "digital_printing.material.view" },
      { label: "Layanan Digital Printing", path: "/digital-printing/services", icon: Palette, perm: "digital_printing.service.view" },
      { label: "Inventory Digital Printing", path: "/inventory/printing", icon: Printer, perm: "inventory.view" },
    ],
  },
  {
    section: "Laporan",
    items: [
      { label: "Laporan Purchasing", path: "/reports/purchasing", icon: FileText, perm: "purchasing.view" },
      { label: "Laporan Purchase Order", path: "/reports/purchase-order", icon: FileText, perm: "purchasing.view" },
      { label: "Laporan Penerimaan", path: "/reports/penerimaan", icon: FileText, perm: "purchasing.view" },
      { label: "Laporan Supplier", path: "/reports/supplier", icon: FileText, perm: "purchasing.view" },
      { label: "Laporan Riwayat Harga", path: "/reports/riwayat-harga", icon: FileText, perm: "purchasing.view" },
      { label: "Laporan Produksi", path: "/reports/produksi", icon: FileText, perm: "production.view" },
      { label: "Laporan Cutting", path: "/reports/cutting", icon: FileText, perm: "production.view" },
      { label: "Laporan Sewing", path: "/reports/sewing", icon: FileText, perm: "production.view" },
      { label: "Laporan Finishing", path: "/reports/finishing", icon: FileText, perm: "production.view" },
      { label: "Laporan QC", path: "/reports/qc", icon: FileText, perm: "production.view" },
      { label: "Laporan Reject / Scrap", path: "/reports/reject", icon: FileText, perm: "production.view" },
      { label: "Laporan Rework", path: "/reports/rework", icon: FileText, perm: "production.view" },
      { label: "Laporan Pemakaian Bahan", path: "/reports/pemakaian-bahan", icon: FileText, perm: "production.view" },
      { label: "Laporan Barang Jadi", path: "/reports/barang-jadi", icon: FileText, perm: "production.view" },
      { label: "Laporan Transfer ke Pusat", path: "/reports/transfer", icon: FileText, perm: "production.view" },
      { label: "Laporan Persediaan Konveksi", path: "/reports/inventory-konveksi", icon: FileText, perm: "inventory.view" },
      { label: "Laporan Digital Printing", path: "/reports/inventory-printing", icon: FileText, perm: "inventory.view" },
      { label: "Laporan Inventory Pusat", path: "/reports/inventory-pusat", icon: FileText, perm: "inventory.view" },
      { label: "Ringkasan Owner", path: "/reports/owner-summary", icon: FileText, perm: "dashboard.owner" },
    ],
  },
  {
    section: "Finance",
    items: [
      { label: "Dashboard Keuangan", path: "/finance/dashboard", icon: Gauge, perm: "finance.view" },
      { label: "Laporan Keuangan", path: "/finance/reports", icon: FileText, perm: "finance.view" },
      { label: "Ringkasan Keuangan Owner", path: "/finance/owner-summary", icon: Scale, perm: "dashboard.owner" },
      { label: "Kontrol Keuangan & Alert", path: "/finance/control", icon: Gauge, perm: "finance.view" },
      { label: "Aset Tetap", path: "/finance/assets", icon: Boxes, perm: "finance.view" },
      { label: "Budget & vs Aktual", path: "/finance/budget", icon: Scale, perm: "budget.view" },
      { label: "Rekonsiliasi Bank", path: "/finance/bank-reconciliation", icon: Landmark, perm: "finance.view" },
      { label: "Kas & Bank", path: "/finance/cash-bank", icon: Landmark, perm: "finance.view" },
      { label: "Tagihan Supplier", path: "/payables/bills", icon: ReceiptText, perm: "payables.view" },
      { label: "Hutang Usaha (AP)", path: "/payables/ap", icon: Wallet, perm: "payables.view" },
      { label: "Pembayaran Supplier", path: "/payables/payments", icon: HandCoins, perm: "payables.view" },
      { label: "Penjualan & Piutang", path: "/sales/receivables", icon: Coins, perm: "ar.view" },
      { label: "Settlement Marketplace", path: "/sales/settlements", icon: Banknote, perm: "ar.view" },
    ],
  },
  {
    section: "Costing (HPP)",
    items: [
      { label: "Dashboard HPP", path: "/costing", icon: LayoutGrid, perm: "costing.view" },
      { label: "Kalkulator HPP", path: "/costing/calculator", icon: Calculator, perm: "costing.view" },
      { label: "Master Harga Kain", path: "/costing/fabric-prices", icon: Coins, perm: "costing.view" },
      { label: "Standar Hasil Kain", path: "/costing/yields", icon: Ruler, perm: "costing.view" },
      { label: "Biaya Jahit", path: "/costing/sewing", icon: Scissors, perm: "costing.view" },
      { label: "Komponen HPP Full", path: "/costing/components", icon: Boxes, perm: "costing.view" },
      { label: "Versi & Riwayat HPP", path: "/costing/hpp", icon: GitBranch, perm: "costing.view" },
      { label: "Aktual vs Standar (Kain)", path: "/costing/actual", icon: Gauge, perm: "costing.view" },
      { label: "Transaksi Menunggu HPP", path: "/costing/waiting", icon: Hourglass, perm: "costing.view" },
    ],
  },
  {
    section: "Accounting",
    items: [
      { label: "Chart of Accounts", path: "/accounting/coa", icon: ListTree, perm: "accounting.view" },
      { label: "Jurnal", path: "/accounting/journals", icon: BookText, perm: "accounting.view" },
      { label: "Buku Besar", path: "/accounting/general-ledger", icon: Wallet, perm: "accounting.view" },
      { label: "Neraca Saldo", path: "/accounting/trial-balance", icon: Scale, perm: "accounting.view" },
      { label: "Closing Period", path: "/accounting/periods", icon: CalendarClock, perm: "accounting.view" },
    ],
  },
  {
    section: "Notifikasi",
    items: [
      { label: "Pusat Notifikasi", path: "/notifications", icon: BellRing, perm: "inventory.view" },
    ],
  },
  {
    section: "SDM (HR)",
    items: [
      { label: "Dashboard HR", path: "/hr/dashboard", icon: Gauge, perm: "hr.view" },
      { label: "Karyawan", path: "/hr/employees", icon: Users, perm: "hr.view" },
      { label: "Absensi", path: "/hr/attendance", icon: ClipboardCheck, perm: "hr.view" },
      { label: "Cuti & Lembur", path: "/hr/leave", icon: CalendarClock, perm: "hr.view" },
      { label: "Payroll", path: "/hr/payroll", icon: Wallet, perm: "hr.payroll.view" },
      { label: "Kebijakan Hari Dibayar", path: "/hr/paid-days-policy", icon: ClipboardCheck, perm: "hr.payroll.view" },
      { label: "Pengaturan Jam Kerja", path: "/hr/work-hours", icon: CalendarClock, perm: "hr.view" },
      { label: "Data Master HR", path: "/hr/masters", icon: ListTree, perm: "hr.view" },
    ],
  },
  {
    section: "Master Data",
    items: [
      { label: "Toko", path: "/master/stores", icon: Store, perm: "masters.view" },
      { label: "Marketplace", path: "/master/marketplaces", icon: Globe, perm: "masters.view" },
      { label: "Satuan", path: "/master/units", icon: Scale, perm: "masters.view" },
    ],
  },
  {
    section: "Users & Access",
    items: [
      { label: "Pengguna", path: "/users", icon: Users, perm: "users.view" },
      { label: "Role & Permission", path: "/roles", icon: ShieldCheck, perm: "roles.manage" },
    ],
  },
  {
    section: "Sistem",
    items: [
      { label: "Audit Log", path: "/audit", icon: ScrollText, perm: "audit.view" },
      { label: "Pengaturan", path: "/settings", icon: SettingsIcon, perm: "settings.manage" },
    ],
  },
];

export const PackageIcon = Package;
